import { render, staticRenderFns } from "./KeyboardKey.vue?vue&type=template&id=2861b3a9&scoped=true"
import script from "./KeyboardKey.vue?vue&type=script&lang=ts"
export * from "./KeyboardKey.vue?vue&type=script&lang=ts"
import style0 from "./KeyboardKey.vue?vue&type=style&index=0&id=2861b3a9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2861b3a9",
  null
  
)

export default component.exports